import React from "react";
import SoftwareCard from "./SoftwareCard";

const softwareData = [
  {
    name: "RioSat Smart IPTV",
    description: "Riosat Smart Iptv Cihazı Güncel Yazılımı",
    downloadUrl: "/files/2517.bin",
    imageUrl: "/files/smart iptv.jpeg", 
  },
  {
    name: "VMS",
    description: "Dijital Video Kayıt Cihazlarımız için VMS/CMS",
    downloadUrl: "/files/VMS.exe",
    imageUrl: "/files/vmsdvrlogo.jpeg", 
  },
  {
    name: "RHD 870/Bravoo Mini HD",
    description: "SCW1 V34.02.06-2 07/03/20204",
    downloadUrl: "/files/SCW1_V34.02.06-2_07-03-2024.bin",
    imageUrl: "/files/rhd870.jpeg", 
  },
  {name:"RHD 870 Çift USB MİNİ HD HV İşlemci",
   description:"",
   downloadUrl:"/files/CİFT USB HD ZETTA 25@32.bin",
   imageUrl:"/files/rhd870.jpeg" 
  }
];

function SoftwareList() {
  return (
    <div className="row">
      {softwareData.map((software, index) => (
        <div className="col-md-4 mb-4" key={index}>
          <SoftwareCard software={software} />
        </div>
      ))}
    </div>
  );
}

export default SoftwareList;
